import { AnyAction, Dispatch, Middleware } from "redux";

const apiRequestMiddleware: Middleware =
  () => (next: Dispatch) => (action: AnyAction) => {
    if (!action.promise) {
      return next(action);
    }

    function makeAction(status: string, data?: any) {
      const newAction = {
        ...action,
        ...{ type: `${action.type}_${status}` },
        ...data,
        originalType: action.type,
      };

      delete newAction.promise;
      return newAction;
    }

    next(makeAction("REQUEST"));
    return action.promise.then(
      (response: Response) => {
        if (response.ok) {
          return response.json().then(
            (json: any) => next(makeAction("SUCCESS", { response, json })),
            () => next(makeAction("SUCCESS", { response }))
          );
        }

        return response.json().then(
          (json: any) => next(makeAction("FAILURE", { response, json })),
          () => next(makeAction("FAILURE", { response }))
        );
      },
      (error: Error) => {
        next(makeAction("ERROR", { error }));
        console.error(error);
      }
    );
  };

export default apiRequestMiddleware;
